import { Route } from "react-router-dom";
import { lazy, Suspense } from "react";

const BlogArticle = lazy(() => import("@/pages/BlogArticle"));
const SecondaryGlazingChelsea = lazy(() => import("@/pages/SecondaryGlazingChelsea"));

const LoadingFallback = () => (
  <div className="flex min-h-[50vh] items-center justify-center">
    <div className="text-center">
      <p className="text-lg">Loading...</p>
    </div>
  </div>
);

export const blogRoutes = [
  <Route 
    key="blog-article" 
    path="/blog/:slug" 
    element={
      <Suspense fallback={<LoadingFallback />}>
        <BlogArticle />
      </Suspense>
    } 
  />,
  <Route
    key="blog-listed-buildings-guide"
    path="/blog/secondary-glazing-listed-buildings-guide"
    element={
      <Suspense fallback={<LoadingFallback />}>
        <SecondaryGlazingChelsea />
      </Suspense>
    }
  />,
];
